import { render, staticRenderFns } from "./SubjectChoose.vue?vue&type=template&id=2ecb43a0&scoped=true"
import script from "./SubjectChoose.vue?vue&type=script&lang=js"
export * from "./SubjectChoose.vue?vue&type=script&lang=js"
import style0 from "./SubjectChoose.vue?vue&type=style&index=0&id=2ecb43a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb43a0",
  null
  
)

export default component.exports